/**
 * A config containing properties for filters
 */
var FilterConfig = /** @class */ (function () {
    function FilterConfig() {
    }
    return FilterConfig;
}());
export { FilterConfig };
//# sourceMappingURL=filter-config.js.map